export const LOCAL_STORAGE_KEY = 'first-point';
export const SESSION_STORAGE_KEY = 'session-point';

export const phone = '+971 56 150 7757';
export const email = 'u.kumar@andersenlab.com';

export const meetupDate = '2025-01-17';
export const meetupTime = '10:00 (GMT+4)';
